import { NativePlatformServiceModule } from 'services/access/nativePlatform/nativePlatform.service';
import { ConciergeIndicatorModule } from 'components/conciergeIndicator/conciergeIndicator.component';
import { SubscriptionServiceModule } from 'services/access/subscription/subscription.service';
import { NavigationMenuServiceModule } from 'components/navigationMenu/services/navigationMenu.service';
import { ImageLibraryModule } from 'components/imageLibrary/imageLibrary.module';
import { NOT_TRIAL } from 'components/trial/trial.service';
import { SpinnerModule } from 'components/spinner/spinner.module';
import { HELP_CENTER_URL, LOGO_SYMBOL_LIGHT_URL, LOGO_SYMBOL_URL } from 'app/constants';
import { ChangePlanClickModule } from 'components/changePlan/changePlanClick.directive';
import { MyAccountServiceModule } from 'services/data/myAccount.service';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { VideoSliderServiceModule } from 'components/videoSlider/videoSlider.service';

import assign from 'lodash/assign';
import uiRouter from '@uirouter/angularjs';

import template from './pageHeader.html';
import './pageHeader.scss';
import '../quickMenu/quickMenu.scss';

export const PageHeaderComponentModule = angular
    .module('app.components.pageHeader.pageHeaderComponent', [
        'ngMaterial',
        uiRouter,
        ConciergeIndicatorModule,
        NativePlatformServiceModule,
        SubscriptionServiceModule,
        NavigationMenuServiceModule,
        ImageLibraryModule,
        SpinnerModule,
        ChangePlanClickModule,
        MyAccountServiceModule,
        LaunchDarklyServiceModule,
        VideoSliderServiceModule
    ]).component('pageHeader', {
        template,
        transclude: {
            overflowMenuItems: '?pageHeaderOverflowMenuItems',
            rightSideContent: '?pageHeaderRightSideContent',
            leftSideContent: '?pageHeaderLeftSideContent',
            afterAddButtonContent: '?pageHeaderAfterAddButtonContent'
        },
        bindings: {
            gtmId: '<',
            theme: '@',

            backButton: '@',
            onBackButtonClick: '&',

            pageTitle: '@',
            pageName: '<',
            hideNav: '<',
            headerClasses: '@',

            showSavebar: '<',
            savebarData: '<',
            savebarForm: '<',
            savebarOnSave: '&',
            savebarOnReset: '&',
            savebarDisableCancel: '<',
            savebarDisableAdd: '<',
            savebarPreferences: '<',
            savebarLabels: '<',
            isDetail: '<',

            showAddButton: '<',
            addButtonText: '@',
            addButtonState: '@',
            onAddButtonClicked: '&',

            showLockButton: '<',
            onLockButtonClicked: '&',

            pageController: '<',
            showSearch: '<',
            searchIndex: '@',
            searchOptions: '<',
            searchFunction: '&?',
            searchDelay: '<',

            exportData: '<',
            exportLoading: '<',
            exportTooltip: '@',

            openUpdateModal: '&',

            hotspotDescription: '@',
            hotspotId: '<',
            hotspotTitle: '@',

            storeInformation: '<',

            menuItemsPosition: '<',
            tabs: '<',
            onTabChange: '<',

            videoLink: '<'
        },
        controller: class PageHeaderCtrl {
            constructor(
                $attrs,
                $mdMedia,
                $scope,
                $rootScope,
                $state,
                $window,
                $mdSidenav,
                nativePlatformService,
                subscriptionsService,
                navigationMenuService,
                videoSliderService,
                trialService,
                myAccountService,
                launchDarklyService
            ) {
                this.hasOnBackButtonClick = angular.isDefined($attrs.onBackButtonClick);
                assign(this, {
                    $mdMedia,
                    $scope,
                    $rootScope,
                    $state,
                    $window,
                    $mdSidenav,
                    LOGO_SYMBOL_LIGHT_URL,
                    LOGO_SYMBOL_URL,
                    nativePlatformService,
                    subscriptionsService,
                    navigationMenuService,
                    videoSliderService,
                    trialService,
                    myAccountService,
                    launchDarklyService,
                    showCallMenu: false,
                    eventHandlers: [],
                    hideVideoButton: false,
                    hasFetchedUserInfo: false,
                    showIntercomButton: true
                });
            }

            $onInit() {
                this.$scope.$watch(() => this.$mdMedia('xs'), (isMatch) => {
                    this.isMobile = isMatch;
                });
                this.$scope.$watch(() => this.$mdMedia('sm'), (isMatch) => {
                    this.isTablet = isMatch;
                });

                this.setMobileAppStatusBar();
                this.setShowCallMenu();
                this.setTrialStatus();
                this.getPhoneNumber();

                this.launchDarklyService.getFeature('use-live-agent-chat').then((useLiveAgentChat) => {
                    this.showIntercomButton = !useLiveAgentChat;
                });

                this.eventHandlers = [
                    this.$rootScope.$on('$stateChangeSuccess', () => {
                        const elem = angular.element(this.$window.document.body);
                        elem.removeClass('side-nav__app--open');
                    }),
                    this.$rootScope.$on('videoSliderModule:sliderOpened', () => {
                        this.hideVideoButton = true;
                    }),
                    this.$rootScope.$on('videoSliderModule:sliderClosed', () => {
                        this.hideVideoButton = false;
                    })
                ];
            }

            $onDestroy() {
                this.eventHandlers.forEach((unbindHandler) => {
                    unbindHandler();
                });
            }

            onBackClick() {
                if (this.searchIndex && this.searchCtrl.searchInitialized) {
                    this.searchCtrl.reset();
                }
                if (this.hasOnBackButtonClick) {
                    this.onBackButtonClick();
                }
            }

            routeOnAddButtonClicked() {
                if (this.addButtonState) {
                    return this.$state.go(this.addButtonState);
                }
                this.onAddButtonClicked();
            }

            openSideNav() {
                this.navigationMenuService.toggle();
            }

            openHelpCenter() {
                this.$window.open(HELP_CENTER_URL, '_blank');
            }

            setMobileAppStatusBar() {
                let kit = this.nativePlatformService.getKit(this.$window);

                if (this.nativePlatformService.isIOS &&
                    this.nativePlatformService.supports(this.$window, 'StatusBarUpdateHandler')) {
                    const backgroundColor = this.getStatusBarBackgroundColor(this.pageTitle);
                    if (backgroundColor) {
                        kit.messageHandlers.StatusBarUpdateHandler.postMessage({
                            statusBarStyle: 'light',
                            statusBarBackgroundColor: backgroundColor
                        });
                    }
                }
                if (this.nativePlatformService.isAndroid &&
                    this.nativePlatformService.supports(this.$window, 'changeStatusBarColor')) {
                    const backgroundColor = this.getStatusBarBackgroundColor(this.pageTitle);
                    if (backgroundColor) {
                        kit.changeStatusBarColor(backgroundColor);
                    }
                }
            }

            getStatusBarBackgroundColor(pageTitle) {
                const pageColorMap = {
                    'All Orders': '#3EC671',
                    products: '#0FB3CC',
                    Categories: '#1E66C3',
                    customers: '#684BB6',
                    Pages: '#C45898',
                    'Theme Store': '#BC7180',
                    'App Store': '#EC6060',
                    'Store Settings': '#FF8055',
                    'Edit Store': '#79919D',
                    'My Account': '#79919D',
                    Analytics: '#4d98f0',
                    'Abandoned Carts': '#4d98f0',
                    Mailchimp: '#52BAD5',
                    Printify: '#2EB56D',
                    Dropshipping: '#1F3856',
                    'Fulfillment Services': '#4747CD',
                    'Live Chat': '#887AAD'
                };
                return pageColorMap[pageTitle];
            }

            setShowCallMenu() {
                this.subscriptionsService.getSubscription()
                    .then((subs) => {
                        this.showCallMenu = subs.features.scheduleCallDisplayed;
                    });
            }

            openVideoSlider() {
                this.videoSliderService.openSlider(this.videoLink);
            }

            setTrialStatus() {
                this.trialService.getTrialStatus().then((status) => {
                    this.isTrialAccount = status !== NOT_TRIAL;
                });
            }

            getPhoneNumber() {
                this.myAccountService.getUser()
                    .then((user) => {
                        this.hasFetchedUserInfo = true;
                        if (user.phoneNumber) {
                            this.phoneNumber = user.phoneNumber;
                        }
                    });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/pageHeader/pageHeader.component.js